import { Box } from "@mui/material";

const CATEGORY_MEDALS = [
  { name: "diamante", src: "/badges/diamante.png" },
  { name: "safira", src: "/badges/safira.png" },
  { name: "ouro", src: "/badges/ouro.png" },
  { name: "prata", src: "/badges/prata.png" },
  { name: "bronze", src: "/badges/bronze.png" },
  { name: "light", src: "/badges/light.png" },
];

function medalSrc(name: string) {
  const normalized = name.trim().toLowerCase();
  return CATEGORY_MEDALS.find(
    (medal) => normalized === medal.name || normalized.startsWith(`${medal.name} `)
  )?.src;
}

export function CategoryMedal({ name, size = 28 }: { name?: string | null; size?: number }) {
  const src = name ? medalSrc(name) : undefined;
  if (!src) return null;

  return (
    <Box
      component="img"
      src={src}
      alt=""
      sx={{ width: size, height: size, flexShrink: 0, objectFit: "contain" }}
    />
  );
}
